import React from 'react';
import './CSS/footer.css';

function Footer() {
  return (
    <div class="footer">
        <p>Website by <a href="mailto:alanalouisecargill@gmail.com"><span class="underline footer-span">Alana Cargill</span></a></p>
    </div>
  );
}

export default Footer;
